import { Breakpoint, Typography } from '@altibox/design-system-component-lib';
import React from 'react';

import { Card } from 'app/components/card';
import { i18n } from 'app/i18n';
import { meshUnitImageProps } from 'app/resources/images';

import { StyledContainer, StyledDescription, StyledSingleMeshUnitImage, StyledTitle } from './single-unit-card.styled';

interface Props {
    onButtonClick: () => void;
    disabled?: boolean;
}

export const SingleUnitCard: React.FC<Props> = (props) => {
    const { ...rest } = props;

    return (
        <Card buttonText={i18n.components.singleUnitCard.button} {...rest}>
            <StyledContainer>
                <StyledSingleMeshUnitImage {...meshUnitImageProps} />
                <div>
                    <StyledTitle variant="paragraph1" component="p" maxBreakpoint={Breakpoint.TABLET}>
                        {i18n.components.singleUnitCard.title}
                    </StyledTitle>
                    <Typography variant="uiText2" component="p">
                        {i18n.components.singleUnitCard.quantity}
                    </Typography>
                </div>
            </StyledContainer>
            <StyledDescription variant="uiText3" component="p" maxBreakpoint={Breakpoint.TABLET}>
                {i18n.components.singleUnitCard.description}
            </StyledDescription>
        </Card>
    );
};
